import { Button, ButtonProps } from 'antd';
import React, { useCallback, useState } from 'react';

export interface IAsyncButtonProps extends ButtonProps {
  onClick: (e: React.MouseEvent<HTMLElement>) => Promise<void>;
}

/**
 * Bottone che gestisce in maniera automatica gli onClick asincroni
 */
export function AsyncButton(props: IAsyncButtonProps) {
  const { onClick, ...otherProps } = props;

  const [loading, setLoading] = useState(false);

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      const fn = async () => {
        setLoading(true);
        await onClick(e);
        setLoading(false);
      };
      fn();
    },
    [onClick],
  );

  return (
    <Button
      {...otherProps}
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      loading={props.loading || loading}
      onClick={handleClick}
    />
  );
}
